export default {
    'testimony': require( './testimony.js' ),
    'challenges': require( './challenges.js' ),
    'header': require( './header.js' ),
    'video': require( './video.js' ),
    'slider': require( './slider.js' ),
    'article-list': require( './article-list.js' ),
    'site-footer':require('./site-footer.js'),
    'form-popin':require('./form-popin.js'),
    'logos':require('./logos.js'),
    'push-article':require('./push-article.js'),
    'site-footer':require('./site-footer.js'),
    'cursor-halo': require('./cursor-halo.js').default,
    'reveal': require('./split-type.js'),
    'site-loader':require('./site-loader.js'),
}
